import { atom } from 'recoil';

type DateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const dashboardDateRangeState = atom<DateRange>({
  key: 'dashboardDateRangeState',
  default: { startDate: null, endDate: null }
});